import React from 'react';
import './Register.css';

export default  class Register extends React.Component {

    render() {
        return(
            <section>
                666
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/Register/Register.js